"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgVk = function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4C75A3",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.707 9.3c.03-.31.248-.47.655-.48.407-.01.989-.01 1.747 0 .503.026.755.232.755.618v2.186c-.006.394.088.613.282.655.292.064.756-.579.983-.95.152-.247.47-.834.956-1.759.074-.306.216-.459.426-.459h2.062c.542.008.703.235.483.682-.22.446-.786 1.275-1.696 2.486-.354.434-.354.805 0 1.115.532.464 1.248 1.24 1.417 1.467.17.227.656 1.085 0 1.085h-2.144a1.661 1.661 0 0 1-1.077-.595c-.427-.506-.796-1.057-1.175-1.065-.252-.006-.425.35-.517 1.065.002.397-.156.595-.472.595-.475 0-1.86.163-2.982-.698-1.122-.86-1.368-1.238-1.947-2.104-.386-.576-.989-1.653-1.807-3.229-.298-.536-.234-.804.189-.804h1.618c.328-.05.584.144.77.58.28.655.715 1.51 1.177 2.05.461.538.753.925.952.198.077-.672.115-1.145.115-1.42-.046-.545-.138-.86-.276-.949a4.797 4.797 0 0 0-.494-.27z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgVk);
var _default = exports["default"] = Memo;